import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router'
import { Head } from '#/components/head'
import { Button } from '#/components/ui/button'
import { Separator } from '#/components/ui/separator'
import { Heading, Text } from '#/components/ui/typography'


export default function StickerLoading() {
  const { t } = useTranslation([ 'stickers' ])
  const params = useParams() as { stickerId: string }
  const { state } = useLocation()

  // Display name might be available from nav state
  const stickerName = state?.name ?? params.stickerId

  return (
    <div className="flex grow flex-col gap-4 items-start">

      <Head title={stickerName} />

      <div className="flex w-full items-end justify-between gap-4">
        <Heading>{stickerName}</Heading>
        <Button className="invisible" />
      </div>

      <Separator />

      <Text>{t('view_sticker.loading')}</Text>

    </div>
  )
}
